import {Store} from '@ngrx/store';
import {AsyncPipe} from '@angular/common';
import {BehaviorSubject, Subject} from 'rxjs';

import {GetTeamsAction} from '../../core/store/teams/teams.action';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';
import {selectAllTeams} from '../../core/store/teams/teams.selector';
import {TitleService} from '../../core/page/title.service';
import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {TeamsHeaderComponent} from '../teams-header/teams-header.component';
import {TeamsTableComponent} from '../teams-table/teams-table.component';

@Component({
  selector: 'teams-main',
  standalone: true,
  imports: [TeamsHeaderComponent, TeamsTableComponent, AsyncPipe, OphLoadingModule],
  templateUrl: './teams-main.component.html',
  styleUrl: './teams-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsMainComponent implements OnInit, OnDestroy {
  private store$ = inject(Store);
  private titleService = inject(TitleService);

  allTeams$ = this.store$.select(selectAllTeams);
  searchValue$ = new BehaviorSubject<string>('');
  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.titleService.setPageTitle('Teams');
    this.store$.dispatch(new GetTeamsAction({}));
  }

  ngOnDestroy(): void {
    this.searchValue$.complete();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
